import { useMemo } from "react";
import { useACLContext } from "../context";
import { stableKey, type CheckSpec } from "./internal";

/**
 * Batch tipado de verificações. Substitui Multiple/Map/Array/Any/All.
 *
 * @example
 * const c = useChecks({
 *   edit: ["update", "posts", { record: post }],
 *   del:  ["delete", "posts", { record: post }],
 * })
 * // c: { edit: boolean; del: boolean }
 * anyOf(c) // alguma
 * allOf(c) // todas
 */
export function useChecks<K extends string>(
  map: Record<K, CheckSpec>,
): Record<K, boolean> {
  const { can, user, revision } = useACLContext();
  const key = stableKey(map);
  return useMemo(() => {
    const out = {} as Record<K, boolean>;
    (Object.keys(map) as K[]).forEach((k) => {
      const [action, resource, opts] = map[k];
      out[k] = can(action, resource, opts);
    });
    return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [can, key, user, revision]);
}

/** true se QUALQUER checagem passou. */
export const anyOf = (result: Record<string, boolean>): boolean =>
  Object.values(result).some(Boolean);

/** true se TODAS passaram (vazio = true). */
export const allOf = (result: Record<string, boolean>): boolean =>
  Object.values(result).every(Boolean);
